export function sortedCopy<T>(array: T[], sort: (a: T, b: T) => number): T[] {
  return [...array].sort(sort);
}
